import { render, staticRenderFns } from "./ExpoBlackHoleUpgradeButton.vue?vue&type=template&id=5d1da3a7&scoped=true&"
import script from "./ExpoBlackHoleUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./ExpoBlackHoleUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1da3a7",
  null
  
)

export default component.exports